// extracted by mini-css-extract-plugin
module.exports = {"textarea":"contact-module--textarea--OteH9","input":"contact-module--input--1ZXDl"};